import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import Upload from '../../../../../assets/icons/dropzone-upload.svg';

import { TXTWCL_JPGX_PNGX_PDF_files_X10MBX } from './DropzoneContent.messages.json';
import { wrapper } from './DropzoneContent.scss';

const DropzoneContent: React.FC = () => (
  <div className={wrapper}>
    <Translation tagName="p" {...TXTWCL_JPGX_PNGX_PDF_files_X10MBX} />
    <Upload />
  </div>
);

DropzoneContent.displayName = 'DropzoneContent';

export default DropzoneContent;
